"use strict";

var _createForOfIteratorHelper = require("/home/jenkins/workspace/roar-the-new-roar-ECS-Prod-2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/home/jenkins/workspace/roar-the-new-roar-ECS-Prod-2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var version_1 = require("../../utils/version");

var variable_replacement_1 = require("../../utils/variable-replacement");

var user_agent_1 = require("../../utils/user-agent");

var libraries = require("../../../fixtures/regexes/client/libraries.json");

var LibraryParser = function LibraryParser(options) {
  var _this = this;

  _classCallCheck(this, LibraryParser);

  this.options = {
    versionTruncation: 1
  };

  this.parse = function (userAgent) {
    var result = {
      type: "",
      name: "",
      version: "",
      url: ""
    };

    var _iterator = _createForOfIteratorHelper(libraries),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var library = _step.value;
        var match = user_agent_1.userAgentParser(library.regex, userAgent);
        if (!match) continue;
        result.type = "library";
        result.name = variable_replacement_1.variableReplacement(library.name, match);
        result.version = version_1.formatVersion(variable_replacement_1.variableReplacement(library.version, match), _this.options.versionTruncation);
        result.url = library.url || "";
        break;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return result;
  };

  this.options = Object.assign(Object.assign({}, this.options), options);
};

exports.default = LibraryParser;